'use strict';

var ACTION_TYPES = require('./actionTypes');

var actionCreators = {
  /**
   * Action for when a material option is clicked
   * @param materialId
   * @returns {{type: string, payload: {materialIds: string, responseInfo: string|null}}}
   */
  materialOptionSelected: function modelMaterialSelected(materialInfo) {
    return {
      type: ACTION_TYPES.MATERIAL_OPTION_SELECTED,
      payload: materialInfo
    };
  },
    /**
     * Action for when the materialNav is closed
     */
  materialNavigationClosed: function materialNavigationClosed() {
    return {
      type: ACTION_TYPES.MATERIAL_NAV_CLOSED
    };
  },
    /**
     * Action for toggling the updateMaterialNav attribute. Which is used for updating during polling.
     * @param materialId
     * @returns {{type: string, payload: bool}}
     */
  materialNavUpdated: function materialNavUpdated(isUpdated) {
    return {
      type: ACTION_TYPES.MATERIAL_NAV_UPDATED,
      payload: isUpdated
    };
  },
    /**
     * Action for modelTitle change
     * @param newTitle
     * @returns {{type: string, payload: string}}
     */
    modelTitleChanged: function modelTitleChanged(newTitle) {
      return {
        type: ACTION_TYPES.MODEL_TITLE_CHANGED,
          payload: newTitle
      };
    },
  /**
   * Action for gray aopt viewer status being marked as complete
   * @returns {{type: *}}
   */
  pollingFor3DViewerCompleted: function pollingFor3dViewerComplete() {
      return {
        type: ACTION_TYPES.POLLING_FOR_3D_VIEWER_COMPLETED
      };
  },
  /**
   * Action for when shapejs(rmr) viewer is first rendered on the page, used as a flag so the shapejs viewer is not rerendered in ThreeDimensionalVizualizer.js
   * @returns {{type: *}}
   */
  realMaterialRenderShown: function realMaterialRenderShown() {
      return {
        type: ACTION_TYPES.REAL_MATERIAL_RENDER_SHOWN
      };
  },
  /**
   * Action for a model's glaze pose being set
   * @returns {{type: *}}
   */
  glazePoseSaved: function glazePoseSaved() {
    return {
      type: ACTION_TYPES.GLAZE_POSE_SAVED
    };
  },
  /**
   * Action for a when a model's details is toggled
   * @returns {{type: *}}
   */
  modelDetailsToggled: function modelDetailsToggled(detailsExpanded) {
    return {
      type: ACTION_TYPES.MODEL_DETAILS_TOGGLED,
      payload: detailsExpanded
    };
  }
};

module.exports = actionCreators;
